// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__GHPvX","label":"Section_label__16kRx","contentWrap":"Section_contentWrap__1c2Ni","footer":"Section_footer__1t29h","footerInner":"Section_footerInner__3EB9B"};